module.exports = __webpack_public_path__ + "img/sugar_hanger_1.cedd4521.png";